var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoOffThin = function SvgVideoOffThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.99a.33.33 0 0 0-.66 0v10.125a.51.51 0 0 1-.827.4L16 14.224l-.411.516 4.028 3.302c.76.606 1.883.065 1.883-.907V6.989Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.61 16.535c0 1.01-.818 1.828-1.828 1.828H9.134a.33.33 0 1 0 0 .66h4.648a2.488 2.488 0 0 0 2.488-2.488v-3.652a.33.33 0 0 0-.66 0v3.652ZM19.902 3.597a.33.33 0 0 0-.466 0L16.233 6.8l-.333-.537a2.486 2.486 0 0 0-2.117-1.18H3.988A2.488 2.488 0 0 0 1.5 7.57v8.965a2.49 2.49 0 0 0 1.647 2.342l.742.267-.887.887a.33.33 0 1 0 .467.466L19.903 4.063a.33.33 0 0 0 0-.466ZM2.16 7.57c0-1.01.819-1.828 1.828-1.828h9.795c.86 0 1.58.593 1.775 1.392l.067.273L4.67 18.363h-.682a1.828 1.828 0 0 1-1.828-1.828V7.57Z"
  }))));
};
export default SvgVideoOffThin;